import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { Injectable, Injector } from '@angular/core';

import { DraftDepotRequeteService } from '../../depot-requete/draft-depot-requete.service';
import { ErrorEnum } from '../../shared/constants/error.constants';
import { HttpCodeEnum } from '../../shared/constants/http-code.constants';
import { catchError, tap } from 'rxjs/operators';
import { HEADER_DRAFT_VERSION } from '../../shared/constants/application.constants';

@Injectable()
export class DraftHeaderInterceptor implements HttpInterceptor {
    private readonly draftUrl = '/api/my-draft-requete';

    constructor(private injector: Injector) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes(this.draftUrl)) {
            let version = this.injector.get<DraftDepotRequeteService>(DraftDepotRequeteService)
                .getDepotRequeteStateVersion();
            /* console.log('===> version: ', version); */
            req = req.clone({
                headers: req.headers.set(HEADER_DRAFT_VERSION, `${version}`)
            });
        }

        return next.handle(req).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse && event.url.includes(this.draftUrl)) {
                    let ver = this.injector
                        .get<DraftDepotRequeteService>(DraftDepotRequeteService)
                        .updateVersionWithResponseHeader(event.headers);
                    console.log('===> response - version: ', ver);
                }
            }),
            catchError(error => {
                if (error && error.url && error.url.includes(this.draftUrl)) {
                    this.processError(error);
                }
                throw error;
            })
        )
    }

    private processError(error: any) {
        const errorBody = error;

        if (error.status === HttpCodeEnum.CONFLICT &&
            errorBody && errorBody.code === ErrorEnum.INVALID_DRAFT_VERSION) {

            this.injector
                .get<DraftDepotRequeteService>(DraftDepotRequeteService)
                .displayDraftModal();
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/blocks/interceptor/draft-header.interceptor.ts